import { Component, OnInit } from '@angular/core';
import { SsInventoryService } from 'shared/services/SS-Inventory/ss-inventory.service';
import { Router, ActivatedRoute } from '@angular/router';
import { DataSharingService } from 'shared/services/data-sharing/data-sharing.service';
import { UserService } from 'shared/services/User/user.service';
import { AppComponent } from 'app/app.component';
import { AlertPopupService } from 'shared/services/SS-Alert/alert-popup.service';
import { VendorsService } from 'shared/services/SS-vendors/vendors.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-choose-team',
  templateUrl: './choose-team.component.html',
  styleUrls: ['./choose-team.component.css']
})
export class ChooseTeamComponent implements OnInit {
  loading: boolean;
  teams: any;

  constructor(
    private inventoryService: SsInventoryService,
    private router: Router,
    private data: DataSharingService,
    private userService: UserService,
    private alertService: AlertPopupService,
    private app: AppComponent,
    private route: ActivatedRoute,
    private tm: VendorsService,

  ) { }

  ngOnInit() {
    this.data.changeTitle('CHOOSE TEAM');
    this.loading = true;
    this.inventoryService.getInventory().subscribe(res => {
      this.loading = false;
      this.teams = res.products;
    }, err => {
      this.loading = false;
      this.alertService.errorAlertWithResult('Team Not Avaiable', 'Go Back', '/new-group');
    });

    this.route.queryParams.subscribe(params => {
      console.log("Params", params)
      let code = params.code;
      // alert(code)
      if (params.state.includes('UPLOAD')) {
        // get the team id
        let teamId = params.state.split('-')[1]
        alert("parsed " + teamId)
        // TO DO Dynamic team id 
        this.tm.connectAccount(code, 144).subscribe(res => { // hard code remove TODO
          console.log("Conneceted ticketmaster")
          let a = res.validateRes.arch_member_id
          console.log(a)
          let b = a.split('.');
          // this.connectedAccountId = b[1];  
          // this.isTeamAccountConnected = true; 
        }, err => {
          // this.isTeamAccountConnected = false; 
          console.log(err)
          this.alertService.errorAlert("Failed to connect your Team Account. Try again or contact support if the error persists. ")
        })
      }
    });
  }
  
  connectTeamAccount(teamId) {
    Swal.fire({
      imageUrl: 'assets/images/logos/ticketmaster.png',
      imageWidth: 250,
      imageAlt: 'Custom image',
      title: "Team Account Lookup",
      text: "You will be redirected to Ticketmaster. After signing in, you can share your Season Ticket.",
      showCancelButton: true,
      confirmButtonText: 'Proceed',
      showLoaderOnConfirm: true,
      preConfirm: () => {
        const redirect_uri = window.location.href;
        window.open(`https://auth.ticketmaster.com/as/authorization.oauth2?lang=en-us&scope=openid profile archtics&client_id=3cd45dd01cc8.seasonshare.integ3-sandbox.us&integratorId=seasonshare&placementId=homepage&visualPresets=integ3&redirect_uri=${redirect_uri}&state=UPLOAD-${teamId}`,
          '_self');
      },
      allowOutsideClick: () => !Swal.isLoading()
    }).then((result) => {
    })
  }

  selectTeam(team) {
    this.app.toggleLoadingMsg('');
    // check if user has a team connected
    if (this.userService.isTeamConnected(team.team_id)) {
      const account_id = this.userService.getTeamAccountID(team.team_id);
      this.app.dismissLoading();
      this.router.navigate(['/new-group/choose-team/upload-plan'], {
        queryParams: {
          acctId: account_id, teamId: team.team_id
        }
      });
    } else {
      // no, user doesnt have team connected - connect a team account
      // here

      // this.router.navigate(['/new-group/choose-team/connect-account'], { queryParams: { eventName: team.pk_ss } });
      this.app.dismissLoading();
      this.connectTeamAccount(team.team_id);
    }
  }

  back() {
    this.router.navigate(['/new-group']);
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/group/components/choose-team/choose-team.component.ts